import { WATCH_CV } from '@/lib/api.js';
export async function fetchUserCV(fileCode, axios) {
  const { data } = await axios.get(`${WATCH_CV}/${fileCode}`, {
    headers: {
      responseType: 'blob'
    }
  });

  const fileLink = document.createElement('a');
  fileLink.href = 'data:application/octet-stream;base64,' + data.FileAsBytes;
  fileLink.setAttribute('download', `${data.FileName}`);
  document.body.appendChild(fileLink);
  fileLink.click();
}
